module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/camera_porch-5643de44d44c41195e5c24d8495053a5.webp";